import Icons from "../models/generated-icons.json";
export default () => ({
    Icons: null,
    init() {
        this.Icons = [ ... Icons ];
        // console.log( "Iconography", { Icons, "this.Icons": this.Icons } );

    }
});
